import { render, staticRenderFns } from "./SmsTextBoxSecondaryFooter.vue?vue&type=template&id=4a293bea&scoped=true"
import script from "./SmsTextBoxSecondaryFooter.vue?vue&type=script&lang=js"
export * from "./SmsTextBoxSecondaryFooter.vue?vue&type=script&lang=js"
import style0 from "./SmsTextBoxSecondaryFooter.vue?vue&type=style&index=0&id=4a293bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a293bea",
  null
  
)

export default component.exports